const SESSION_TIME = 60 * 60 * 1000;

export const setSession = ({
  email,
  projectName,
  projectId,
  organizationName,
  roleId, 
}) => {
  const expiry = new Date().getTime() + SESSION_TIME;

  const sessionData = {
    email,
    projectName,
    projectId,
    organizationName,
    roleId, // ✅ NEW
    expiry,
  };

  sessionStorage.setItem("userSession", JSON.stringify(sessionData));
};

// ✅ Get session (no change needed)
export const getSession = () => {
  const data = sessionStorage.getItem("userSession");

  if (!data) return null;

  const parsed = JSON.parse(data);

  // ⏳ Expiry check
  if (new Date().getTime() > parsed.expiry) {
    sessionStorage.removeItem("userSession");
    return null;
  }

  return parsed;
};

// ✅ Clear session
export const clearSession = () => {
  sessionStorage.removeItem("userSession");
};